'use client'

import { Text } from '@dd3tech/wiggui/Text'
import { Modal } from '@dd3tech/wiggui/Modal'
import { Button } from '@dd3tech/wiggui/Button'
import { ROUTES } from '../../../../constants'
import { useModalTermsAndConditions } from './hooks'

export const ModalTermsAndConditions = () => {
  const { handleAccept, handleReject, isLoading, isOpen, isLoadingReject } =
    useModalTermsAndConditions()

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => ({})}
      enableBgBlur
      className="w-fit max-w-lg"
    >
      <Modal.Header
        isShowCloseButton={false}
        title="Cambios en los términos de uso"
        isShowDivider
      />
      <Modal.Body>
        <Text className="text-body-m text-primary">
          Actualizamos nuestros{' '}
          <a
            href={ROUTES.TERMS_AND_CONDITIONS}
            target="_blank"
            className="text-button-primary font-semibold underline hover:brightness-75"
            rel="noreferrer"
          >
            términos y condiciones
          </a>{' '}
          y el{' '}
          <a
            href={ROUTES.PRIVACITY}
            target="_blank"
            className="text-button-primary font-semibold underline hover:brightness-75"
            rel="noreferrer"
          >
            aviso de privacidad
          </a>
          , revísalos y acéptalos para poder continuar.
        </Text>
      </Modal.Body>
      <Modal.Footer className="flex-row flex py-3 border-t gap-3 border-surface-strokes items-center w-full px-6 justify-between">
        <Button
          isLoading={isLoadingReject}
          fullWidth
          variant="terciary"
          onClick={(event) => {
            event.stopPropagation()
            handleReject()
          }}
        >
          No acepto
        </Button>
        <Button
          isLoading={isLoading}
          fullWidth
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation()
            handleAccept()
          }}
        >
          Acepto
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
